import * as React from 'react';
import config from '../config/config';
import { TaskBoardCard } from '@progress/kendo-react-taskboard';
import { CardBody } from '@progress/kendo-react-layout';

// Cache für Avatar-URLs
const avatarUrlCache = new Map();

const getAvatarUrl = (avatarThumbLink) => {
  if (!avatarThumbLink) return null;
  if (!avatarUrlCache.has(avatarThumbLink)) {
    const timestamp = Date.now();
    const url = `${config.host}/get_image/${avatarThumbLink.split('/').map(encodeURIComponent).join('/')}?t=${timestamp}`;
    avatarUrlCache.set(avatarThumbLink, url);
  }
  return avatarUrlCache.get(avatarThumbLink);
};

const CardHeaderComponent = props => {
  const avatarUrl = getAvatarUrl(props.task.avatarThumbLink);
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {avatarUrl && (
        <img
          src={avatarUrl}
          alt={`Avatar for ${props.task.title}`}
          draggable={false}
          style={{
            width: '30px',
            height: '30px',
            borderRadius: '50%',
            objectFit: 'cover',
            marginRight: '8px'
          }}
        />
      )}
      <span style={{ fontWeight: 'bold' }}>
        {props.task.description || props.task.title}
      </span>
    </div>
  );
};

const CardBodyComponent = props => {
  return <CardBody style={{ padding: 0 }} />;
};

export const Card = props => {
  return <TaskBoardCard {...props} style={{ padding: 5 }} cardHeader={CardHeaderComponent} cardBody={CardBodyComponent} />;
};